export const productsets = $state({
  // De renderbare ProductSet-descriptors (zichtbaar in de reserveerstraat + geldig geconfigureerd).
  aItems: [],
  // Alle product-IDs die lid zijn van welke persisted ProductSet dan ook. NB: dit is bewust een
  // aparte payload en NIET afleidbaar uit aItems, want het bevat ook de leden van verborgen/
  // onvolledige sets. Membership is structureel: een set uitzetten mag zijn producten niet
  // opeens weer als losse card laten verschijnen. Wordt alleen gebruikt door
  // isProductInPersistedSet() -> shouldRenderProductStandalone(). Dit is catalogus-state; keuzes
  // van de gast staan in feature.booking.
  aProductIDsInPersistedSets: []
});

window.hmk_productsets = () => {
  console.log($state.snapshot(productsets));
};
